function stubObject() {
    return {};
}

export { stubObject };
